import {createAsyncThunk} from "@reduxjs/toolkit";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import axios from "axios";
import {SettingGroupsResponse} from "../../../types/settingGroups";
import {settingsReceived} from "../../../slice/groups/set-groups-lessons/set-setting-group/setSettingGroup";


interface PostGroupsParams {
    requestData?: {
        considerHomework: boolean;
        considerAttendance: boolean;
        considerProgressCuts: boolean;
        remindStudents: boolean;
        remindStudentsTime: number
        remindTeacher: boolean;
        remindTeacherTime: number
    };
    groupId: string | undefined;
}


export const fetchSettingGroup = createAsyncThunk<SettingGroupsResponse, PostGroupsParams>(
    'groups/settingGroups',
    async ({requestData, groupId}, thunkAPI) => {

        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('Не найден токен в локальном хранилище.');
            }
            const {token} = JSON.parse(authToken);
            const response = await axios.put<SettingGroupsResponse>(
                `/api/groups/${groupId}/settings`,
                requestData,
                {
                    headers:{
                        Authorization: `Bearer ${token}`,
                    }
                }
            );
            thunkAPI.dispatch(settingsReceived(response.data.data));

            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue('error');
        }
    }
)